export class Round {
    constructor(id, tables) {
        this.id = id;
        this.tables = tables;
    }
}